import React from 'react';
import { motion } from 'framer-motion';
import { FaInstagram, FaFacebookF, FaTwitter, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './SocialMediaFeeds.css';

const SocialMediaFeeds = ({ showTitle = true }) => {
  return (
    <section className="social-feed-section">
      <div className="container">
        {showTitle && (
          <motion.div 
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2>Connect With Us</h2>
            <p>Follow our social media channels for the latest updates and projects</p>
          </motion.div>
        )}
        
        {/* Scroll navigation buttons */}
        <div className="scroll-nav-buttons">
          <button 
            className="scroll-button prev" 
            onClick={() => {
              const container = document.querySelector('.social-feed-container');
              container.scrollBy({ left: -550, behavior: 'smooth' });
            }}
            aria-label="Previous social media card"
          >
            <FaChevronLeft />
          </button>
          <button 
            className="scroll-button next" 
            onClick={() => {
              const container = document.querySelector('.social-feed-container');
              container.scrollBy({ left: 550, behavior: 'smooth' });
            }}
            aria-label="Next social media card"
          >
            <FaChevronRight />
          </button>
        </div>
        
        <div className="social-feed-container">
          {/* Instagram Feed */}
          <motion.div 
            className="social-feed-card instagram-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <div className="social-feed-header">
              <div className="social-feed-icon instagram">
                <FaInstagram />
              </div>
              <h3>Instagram</h3>
              <a href="https://www.instagram.com/houseofcanvastz/" target="_blank" rel="noopener noreferrer" className="follow-link">
                Follow
              </a>
            </div>
            <div className="social-feed-content">
              <div className="instagram-embed-container">
                <iframe
                  title="Instagram Feed"
                  src="https://www.instagram.com/houseofcanvastz/embed"
                  width="100%"
                  height="550"
                  frameBorder="0"
                  scrolling="no"
                  allowTransparency="true"
                ></iframe>
              </div>
            </div>
          </motion.div>
          
          {/* Facebook Feed */}
          <motion.div 
            className="social-feed-card facebook-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="social-feed-header">
              <div className="social-feed-icon facebook">
                <FaFacebookF />
              </div>
              <h3>Facebook</h3>
              <a href="https://www.facebook.com/House.Of.Canvas.Limited/" target="_blank" rel="noopener noreferrer" className="follow-link">
                Follow
              </a>
            </div>
            <div className="social-feed-content">
              <div className="facebook-embed-container">
                <iframe
                  title="Facebook Feed"
                  src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FHouse.Of.Canvas.Limited%2F&tabs=timeline&width=500&height=550&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                  width="500"
                  height="550"
                  style={{ border: 'none', overflow: 'hidden', width: '100%' }}
                  scrolling="no"
                  frameBorder="0"
                  allowTransparency="true"
                  allow="encrypted-media"
                ></iframe>
              </div>
            </div>
          </motion.div>
          
          {/* Twitter Feed */}
          <motion.div 
            className="social-feed-card twitter-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <div className="social-feed-header">
              <div className="social-feed-icon twitter">
                <FaTwitter />
              </div>
              <h3>Twitter</h3>
              <a href="https://twitter.com/houseofcanvas" target="_blank" rel="noopener noreferrer" className="follow-link">
                Follow
              </a>
            </div>
            <div className="social-feed-content">
              <div className="twitter-embed-container">
                <blockquote className="twitter-tweet" data-theme="light" data-lang="en" data-date="July 15, 2023">
                  <p lang="en" dir="ltr">
                    Proud to announce our latest luxury safari tent installation at Serengeti National Park! Our premium tents blend seamlessly with nature while providing unmatched comfort. 
                    <a href="https://twitter.com/houseofcanvas">#LuxurySafari</a> 
                    <a href="https://twitter.com/houseofcanvas">#TanzaniaTourism</a>
                  </p>
                  &mdash; House of Canvas (@houseofcanvas)
                </blockquote>
                
                <blockquote className="twitter-tweet" data-theme="light" data-lang="en" data-date="August 3, 2023">
                  <p lang="en" dir="ltr">
                    Check out our latest tent installations at <a href="https://twitter.com/houseofcanvas">#SafariCamps</a> across Tanzania! 
                    Our premium quality tents are designed to withstand all weather conditions while providing luxury and comfort.
                  </p>
                  &mdash; House of Canvas (@houseofcanvas)
                </blockquote>
                
                <blockquote className="twitter-tweet" data-theme="light" data-lang="en" data-date="September 12, 2023">
                  <p lang="en" dir="ltr">
                    Excited to announce our expansion into the Kenyan market! Now serving clients across East Africa with our premium tent solutions.
                    <a href="https://twitter.com/houseofcanvas">#EastAfrica</a>
                  </p>
                  &mdash; House of Canvas (@houseofcanvas)
                </blockquote>
                
                <blockquote className="twitter-tweet" data-theme="light" data-lang="en" data-date="October 5, 2023">
                  <p lang="en" dir="ltr">
                    Our team just completed a beautiful wedding tent setup in Dar es Salaam. Congratulations to the happy couple! 
                    <a href="https://twitter.com/houseofcanvas">#WeddingTents</a> 
                    <a href="https://twitter.com/houseofcanvas">#EventTents</a>
                  </p>
                  &mdash; House of Canvas (@houseofcanvas)
                </blockquote>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SocialMediaFeeds; 